import React, { Component } from 'react';
import "./index.scss";
import { IGameResultHistoryProps } from "@/types/GameHistoryTypes";
 
export default class M11 extends Component<IGameResultHistoryProps> {
	History(props) {
		const angka = props.angka.split(',');
		return (
			<div className="rowHB">
			{
				angka.map((item, idx) => 
					<div key={`grh_m11_hb_${idx}`} className={"hb history-box-" + Number(item) + " " + (props.blink ? "sl-roadmap-alternating" : "")}>
						{ Number(item) === 3 ? "JP" : "" }
					</div>
				)
			}
			</div>
		);
	}
	
	render() {
		const reversedHistory = this.props.history.slice(0).reverse();
		const History = this.History;
		const historyBlink = this.props.historyBlink;
		
		return (
			<div className="history-container m11">
				{
					this.props.activeGameCount === 1 ?
					reversedHistory.slice(0, 7).map((data, idx) =>
						<History
							angka={data.angka}
							blink={historyBlink && idx === 0}
							key={`grh_m11_max_${idx}`} />
					) :
					reversedHistory.slice(0, 6).map((data, idx) =>
						<History
							angka={data.angka}
							blink={historyBlink && idx === 0}
							key={`grh_m11_mult_${idx}`} />
					)
				}
			</div>
		);
	}
}
